import { InjectionToken } from '@angular/core';

export const APP_CONFIG_TOKEN = new InjectionToken('config');
